import React, { useState, useRef, useLayoutEffect, useCallback } from "react";
import { Typography, IconButton, Box } from "@mui/material";

const ReadMoreText = ({ text, line = 4 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [lineHeight, setLineHeight] = useState(0);
    const textRef = useRef(null);

    const checkOverflow = useCallback(() => {
        if (textRef.current) {
            const computedStyle = getComputedStyle(textRef.current);
            const calculatedLineHeight = parseInt(computedStyle.lineHeight, 10);
            const maxVisibleHeight = calculatedLineHeight * 1;
            setLineHeight(calculatedLineHeight);
            setIsOverflowing(textRef.current.scrollHeight > maxVisibleHeight);
        }
    }, []);

    useLayoutEffect(() => {
        checkOverflow();
    }, [text, checkOverflow]);

    return (
        <Box sx={{ minHeight: lineHeight * line || "unset" }}>
            <Box
                sx={{
                    minHeight: lineHeight * line - 1,
                    maxHeight: isExpanded ? "none" : lineHeight * 1,
                    overflow: "hidden",
                    WebkitLineClamp: isExpanded ? "unset" : 1,
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    textOverflow: "ellipsis",
                }}
            >
                <Typography
                    ref={textRef}
                    variant="h6"
                    color="secondary.light"
                    lineHeight={"18px"}
                >
                    {text}
                </Typography>
            </Box>

            {isOverflowing && (
                <IconButton onClick={() => setIsExpanded(!isExpanded)} sx={{ padding: 0 }}>
                    <Typography variant="h6" fontWeight={500} color="blue.main">
                        {isExpanded ? "Read Less" : "Read More"}
                    </Typography>
                </IconButton>
            )}
        </Box>
    );
};

export default ReadMoreText;
